import {
  SET_ERROR,
  SET_SUCCESS,
  SET_FETCHING,
  SET_CLOSE,
  SET_CLEAR,
  RESET_REQUEST,
} from "../actions/actionsTypes";

const initialState = {
  type: null,
  statusCode: 0,
  message: "",
  isFetching: false,
  isOpen: false,
};

export const requestReducer = (state = initialState, action) => {
  if (action.type === SET_ERROR) {
    const { type, message, isOpen, statusCode } = action.payload;
    return {
      ...state,
      type,
      message,
      isOpen,
      statusCode,
    };
  }
  if (action.type === SET_SUCCESS) {
    const { type, message, isOpen } = action.payload;
    return {
      ...state,
      type,
      message,
      isOpen,
    };
  }
  if (action.type === SET_FETCHING) {
    const { isFetching } = action.payload;
    return {
      ...state,
      isFetching,
    };
  }
  if (action.type === SET_CLOSE) {
    return {
      ...state,
      isOpen: false,
    };
  }
  if (action.type === SET_CLEAR) {
    return state;
  }
  if (action.type === RESET_REQUEST) {
    return {
      ...initialState,
    };
  }
  return {
    type: "",
    statusCode: 0,
    message: "",
    isFetching: false,
    isOpen: false,
  };
};
